import {
  Box,
  Card,
  FormControl,
  CardContent,
  Grid,
  TextField,
  Autocomplete,
  FormControlLabel,
  RadioGroup,
  FormHelperText,
  MenuItem,
} from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import CustomFormLabel from "../../../components/forms/custom-elements/CustomFormLabel";
import CustomTextField from "../../../components/forms/custom-elements/CustomTextField";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import CustomRadio from "../../../components/forms/custom-elements/CustomRadio";
import CustomCheckbox from "../../../components/forms/custom-elements/CustomCheckbox";

export const AddVisitor = (props) => {
  let captureForm = useFormikContext();
  
  const { values, handleChange, setFieldValue, employeeData, departments, view,visibleSunday,handleSunday,checkSunday,setCheckSunday,dept } =
  props;

  return (
    // <Card>
    <Box>
      <FormControl
        sx={{
          width: "100%",
        }}
      >
        <Box sx={{ ml: 0, mt: 0 }}>
          <CardContent
            sx={{
              padding: "10px 30px 10px 30px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={4} md={12} sm={12} xs={12}>
                <CustomFormLabel htmlFor="SelectType">Select Type</CustomFormLabel>
                <Autocomplete
                  id="SelectType"
                  options={[
                    { label: "Visiting to", value: "Visiting to" },
                    { label: "Visitor", value: "Visitor" }
                  ]}
                  getOptionLabel={(option) => option.label}
                  fullWidth
                  size="small"
                  value={
                    [{ label: "Visiting to", value: "Visiting to" }, { label: "Visitor", value: "Visitor" }]
                      .find(opt => opt.value === values.SelectType) || { label: "Visitor", value: "Visitor" }
                  }
                  onChange={(event, newValue) => {
                    setFieldValue("SelectType", newValue ? newValue.value : "Visitor");
                    setFieldValue("department", "");
                  }}
                  variant="outlined"
                  disabled={view}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        captureForm.touched?.SelectType && captureForm.errors?.SelectType
                      )}
                      helperText={
                        captureForm.touched?.SelectType && captureForm.errors?.SelectType
                      }
                    />
                  )}
                />
              </Grid>
              {values.SelectType === "Visitor" && (
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Person To Meet</CustomFormLabel>
                <Autocomplete
                  id="initiatorName"
                  options={employeeData}
                  getOptionLabel={(option) => option.personName}
                  fullWidth
                  size="small"
                  disabled={view}
                  value={
                    employeeData.find(
                      (option) =>
                        option.personName === captureForm.values.initiatorName
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    captureForm.setFieldValue(
                      "initiatorName",
                      newValue ? newValue.personName : ""
                    );
                    captureForm.setFieldValue(
                      "visitorId",
                      newValue.employeeId
                    );
                    if (values.SelectType === "Visitor") {
                      captureForm.setFieldValue("department", newValue.empDept);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      error={Boolean(
                        captureForm.touched.initiatorName &&
                        captureForm.errors.initiatorName
                      )}
                      helperText={
                        captureForm.touched.initiatorName &&
                        captureForm.errors.initiatorName
                      }
                    />
                  )}
                />
              </Grid>
              )}
              {values.SelectType === "Visiting to" && (
                <Grid item lg={4} md={12} sm={12}>
                  <CustomFormLabel htmlFor="hostPersonToMeet">
                    Person To Meet
                  </CustomFormLabel>
                  <CustomTextField
                    id="hostPersonToMeet"
                    name="hostPersonToMeet"
                    variant="outlined"
                    fullWidth
                    size="small"
                    disabled={view}
                    {...captureForm.getFieldProps("hostPersonToMeet")}
                    error={Boolean(
                      captureForm.touched?.hostPersonToMeet && captureForm.errors?.hostPersonToMeet
                    )}
                    helperText={
                      captureForm.touched?.hostPersonToMeet && captureForm.errors?.hostPersonToMeet
                    }
                  />
                </Grid>
              )}
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Department </CustomFormLabel>
                <Autocomplete
                      id="department"
                      options={
                        values.SelectType === "Visiting to"
                          ? dept.filter((d) => d.departmentName?.trim()) // remove empty names
                          : values.department
                            ? [{ departmentName: values.department }]
                            : []
                      }
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.departmentName?.toString() || ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.departmentName === value?.departmentName
                      }
                      fullWidth
                      size="small"
                      disabled={view}
                      value={
                        dept.find((d) => d.departmentName === values.department) ||
                        (values.department ? { departmentName: values.department } : null)
                      }
                      onChange={(event, newValue) => {
                        captureForm.setFieldValue(
                          "department",
                          newValue ? newValue.departmentName : ""
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          error={Boolean(
                            captureForm.touched.department && captureForm.errors.department
                          )}
                          helperText={
                            captureForm.touched.department && captureForm.errors.department
                          }
                        />
                      )}
                    />

              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>No.of Person Come </CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="noofPerson"
                  name="noofPerson"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={view}
                  {...captureForm.getFieldProps("noofPerson")}
                  error={Boolean(
                    captureForm.touched?.noofPerson &&
                    captureForm.errors?.noofPerson
                  )}
                  helperText={
                    captureForm.touched?.noofPerson &&
                    captureForm.errors?.noofPerson
                  }
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>
                   {values.SelectType === "Visiting to" ? "Visiting to Company" : "Representing"}
                </CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="representing"
                  name="representing"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={view}
                  {...captureForm.getFieldProps("representing")}
                  error={Boolean(
                    captureForm.touched?.representing && captureForm.errors?.representing
                  )}
                  helperText={
                    captureForm.touched?.representing && captureForm.errors?.representing
                  }
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Contact No</CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="contactNO"
                  name="contactNO"
                  variant="outlined"
                  fullWidth
                  size="small"
                  inputProps={{ maxLength: 10 }}

                  disabled={view}
                  {...captureForm.getFieldProps("contactNO")}
                  error={Boolean(
                    captureForm.touched?.contactNO &&
                    captureForm.errors?.contactNO
                  )}
                  helperText={
                    captureForm.touched?.contactNO &&
                    captureForm.errors?.contactNO
                  }
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>
                  {values.SelectType === "Visiting to" ? "SS White Representative" : "Visiting Person Name"}
                </CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="visitingPersonname"
                  name="visitingPersonname"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={view}
                  {...captureForm.getFieldProps("visitingPersonname")}
                  error={Boolean(
                    captureForm.touched?.visitingPersonname &&
                    captureForm.errors?.visitingPersonname
                  )}
                  helperText={
                    captureForm.touched?.visitingPersonname &&
                    captureForm.errors?.visitingPersonname
                  }
                />
              </Grid>

              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Visiting Date</CustomFormLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disabled={view}
                    value={values.visitingDate}
                    // onChange={(newValue) => {
                    //   setFieldValue("Visitingdate", newValue);
                    // }}
                    onChange={(newValue) => {
                      setFieldValue("visitingDate", newValue);
                      setFieldValue(
                        "dateText",
                        moment(newValue).format("YYYY-MM-DD")
                      );
                    }}
                    renderInput={(props) => (
                      <CustomTextField
                        variant="outlined"
                        name="date"
                        fullWidth
                        size="small"
                        {...props}
                        error={Boolean(
                          captureForm.touched?.visitingDate && captureForm.errors?.visitingDate
                        )}
                        helperText={
                          captureForm.touched?.visitingDate && captureForm.errors?.visitingDate
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
                    
              

              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Visiting In Time</CustomFormLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    value={
                      values.visitingTime
                        ? new Date(`1970-01-01T${values.visitingTime}`) // Convert string to Date for "View" mode
                        : null // Handle empty value for "Add" mode
                    }
                    onChange={(newValue) => {
                      if (newValue) {
                        const formattedTime = newValue.toTimeString().split(" ")[0]; // Format time as "HH:mm:ss"
                        setFieldValue("visitingTime", formattedTime); // Update formik value
                      } else {
                        setFieldValue("visitingTime", ""); // Clear the value if no time is selected
                      }
                    }}
                    disabled={view}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        fullWidth
                        size="small"
                        error={Boolean(
                          captureForm.touched?.visitingTime &&
                          captureForm.errors?.visitingTime
                        )}
                        helperText={
                          captureForm.touched?.visitingTime &&
                          captureForm.errors?.visitingTime
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Valid Upto</CustomFormLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={values.validUpto}
                    // onChange={(newValue) => {
                    //   setFieldValue("Visitingdate", newValue);
                    // }}
                    onChange={(newValue) => {
                      setFieldValue("validUpto", newValue);
                      setFieldValue(
                        "dateText",
                        moment(newValue).format("YYYY-MM-DD")
                      );
                    }}
                    disabled={view}
                    renderInput={(props) => (
                      <CustomTextField
                        variant="outlined"
                        name="date"
                        fullWidth
                        size="small"
                        {...props}
                        {...captureForm.getFieldProps("validUpto")}
                        error={Boolean(
                          captureForm.touched?.validUpto && captureForm.errors?.validUpto
                        )}
                        helperText={
                          captureForm.touched?.validUpto && captureForm.errors?.validUpto
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Visiting Out Time</CustomFormLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    value={
                      values.out_Time
                        ? new Date(`1970-01-01T${values.out_Time}`) // Convert string to Date for "View" mode
                        : null // Handle empty value for "Add" mode
                    }
                    onChange={(newValue) => {
                      if (newValue) {
                        const formattedTime = newValue.toTimeString().split(" ")[0]; // Format time as "HH:mm:ss"
                        setFieldValue("out_Time", formattedTime); // Update formik value
                      } else {
                        setFieldValue("out_Time", ""); // Clear the value if no time is selected
                      }
                    }}
                    disabled={view}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        fullWidth
                        size="small"
                        error={Boolean(
                          captureForm.touched?.out_Time &&
                          captureForm.errors?.out_Time
                        )}
                        helperText={
                          captureForm.touched?.out_Time &&
                          captureForm.errors?.out_Time
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item lg={4} md={12} sm={12} xs={12}>
               <CustomFormLabel>
                  {values.SelectType === "Visiting to" ? "Visiting To City" : "Visiting From City"}
                </CustomFormLabel>
                <CustomTextField
                  id="location"
                  name="location"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={view}
                  {...captureForm.getFieldProps("location")}
                  error={Boolean(
                    captureForm.touched?.location && captureForm.errors?.location
                  )}
                  helperText={
                    captureForm.touched?.location && captureForm.errors?.location
                  }
                />
              </Grid>
              {/* <CustomTextField
                  type="text"
                  id="validUpto"
                  name="validUpto"
                  variant="outlined"
                  fullWidth
                  size="small"
                  // disabled={view}
                  {...captureForm.getFieldProps("validUpto")}
                  error={Boolean(
                    captureForm.touched?.validUpto && captureForm.errors?.validUpto
                  )}
                  helperText={
                    captoucureForm.thed?.validUpto && captureForm.errors?.validUpto
                  }
                />
              </Grid> */}
              <Grid item lg={8} md={12} sm={12}>
                <CustomFormLabel>Purpose</CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="purpose"
                  name="purpose"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={view}
                  {...captureForm.getFieldProps("purpose")}
                  error={Boolean(
                    captureForm.touched?.purpose && captureForm.errors?.purpose
                  )}
                  helperText={
                    captureForm.touched?.purpose && captureForm.errors?.purpose
                  }
                />
              </Grid>
              <Grid item lg={3} md={12} sm={12} xs={12}>
                <CustomFormLabel
                  sx={{
                    mt: 2,
                  }}
                  htmlFor="visitingType"
                >
                  Visiting Type
                </CustomFormLabel>
                <FormControl
                  sx={{
                    width: "100%",
                  }}
                >
                  <Box>
                    <RadioGroup
                      row
                      aria-label="receiptMethod"
                      name="visitingType"
                      value={values.visitingType}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        disabled={view}
                        value={"Office"}
                        control={<CustomRadio />}
                        label="Office"
                      />
                      <FormControlLabel
                        disabled={view}
                        value={"Shop Floor"}
                        control={<CustomRadio />}
                        label="Shop Floor"
                      />
                      <FormControlLabel
                        disabled={view}
                        value={"Both"}
                        control={<CustomRadio />}
                        label="Both"
                      />
                    </RadioGroup>
                  </Box>
                </FormControl>
              </Grid>
              
              
              {visibleSunday && (
                <Grid item lg={1} mt={5}>
                  <FormControlLabel
                    control={
                      <CustomCheckbox
                        name="isSunday"
                        color="primary"
                        onChange={(e) => {
                          captureForm.setFieldValue("isSunday", e.target.checked  ? true : false);
                          setCheckSunday(e.target.checked);
                        }}
                        checked={checkSunday === true}
                        error={Boolean(
                          captureForm.touched?.isSunday && captureForm.errors?.isSunday
                        )}
                      />
                    }
                    label="Sunday"
                  />
                  {captureForm.touched.isSunday && captureForm.errors.isSunday && (
                    <FormHelperText error>
                      {captureForm.errors.isSunday}
                    </FormHelperText>
                  )}
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Box>
      </FormControl>
    </Box>
    // </Card>
  );
};
